var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8297 18.9993C13.6803 18.9998 13.5327 18.9668 13.3977 18.9028C13.2627 18.8388 13.1438 18.7453 13.0497 18.6293L8.21968 12.6293C8.07259 12.4504 7.99219 12.2259 7.99219 11.9943C7.99219 11.7627 8.07259 11.5382 8.21968 11.3593L13.2197 5.3593C13.3894 5.15508 13.6333 5.02666 13.8978 5.00228C14.1622 4.9779 14.4255 5.05956 14.6297 5.2293C14.8339 5.39904 14.9623 5.64295 14.9867 5.90738C15.0111 6.1718 14.9294 6.43508 14.7597 6.6393L10.2897 11.9993L14.6097 17.3593C14.732 17.5061 14.8096 17.6848 14.8335 17.8744C14.8574 18.0639 14.8265 18.2563 14.7444 18.4289C14.6624 18.6014 14.5326 18.7468 14.3705 18.8479C14.2084 18.949 14.0207 19.0015 13.8297 18.9993Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/back_arrow.dea6f045577e343de0b42c48ec73aaff.svg";
export { ForwardRef as ReactComponent };